var map = {
	"./chat/chat.module": [
		"./src/app/chat/chat.module.ts",
		"common",
		"chat-chat-module"
	],
	"./dashboard/dashboard.module": [
		"./src/app/dashboard/dashboard.module.ts",
		"common",
		"dashboard-dashboard-module"
	],
	"./managemenu/managemenu.module": [
		"./src/app/managemenu/managemenu.module.ts",
		"default~managemenu-managemenu-module~promozioni-promozioni-module",
		"common",
		"managemenu-managemenu-module"
	],
	"./managetable/managetable.module": [
		"./src/app/managetable/managetable.module.ts",
		"common",
		"managetable-managetable-module"
	],
	"./manageuser/manageuser.module": [
		"./src/app/manageuser/manageuser.module.ts",
		"common",
		"manageuser-manageuser-module"
	],
	"./promozioni/promozioni.module": [
		"./src/app/promozioni/promozioni.module.ts",
		"default~managemenu-managemenu-module~promozioni-promozioni-module",
		"common",
		"promozioni-promozioni-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;